import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupInformacoesAdicionais(): void {
  applicationModuleRegistry.register({
    entry: 'informacoes-adicionais',
    id: 'informacoes-adicionais',
    name: 'beneficiary.informacoes-adicionais',
    route: Routes.INFORMACOES_ADICIONAIS,
    order: 11,
    closeable: true,
  });
}
